/** Palet warna SEISM — terang, jernih, terinspirasi alam & budaya Bengkulu */
export const PALETTE = {
  skyLight: 0xbfe9ff,
  skyDeep: 0x5497d6,
  forestDark: 0x21533d,
  forestMid: 0x3a7a4f,
  forestLight: 0x6bbf7d,
  woodDark: 0x5d3a22,
  woodMid: 0x9a6a3f,
  woodLight: 0xe7c487,
  soilDark: 0x6d4d35,
  rafflesia: 0xc92f3b,
  rafflesiaLight: 0xf45b69,
  rafflesiaSpot: 0xf7d35c,
  skin: 0xffddb8,
  skinShadow: 0xf0c090,
  hairDark: 0x4a2810,
  white: 0xffffff,
  black: 0x1a1a2e,
  gold: 0xf2c14e,
  kerisBlade: 0xd6eefc,
  kerisHandle: 0xa66b3f,
  grass: 0x78c97f,
  grassBright: 0x9cde8e,
  earth: 0x9b8773,
  earthLight: 0xc9b08a,
  water: 0x67c7ea,
  waterDeep: 0x2d7fb8,
  tigerOrange: 0xe2892d,
  tigerStripe: 0x4a2810,
  monkeyBrown: 0xa7743e,
  clothGreen: 0x3d8a52,
  clothRed: 0xb3372f,
  clothWarm: 0xd9865f,
  clothPurple: 0x7f4aa8,
  clothBlue: 0x2b6aa8,
  stone: 0x73808f,
  stoneLight: 0xa4b0bb,
  mist: 0xeaf6ff,
  danger: 0xc44536,
  outline: 0x2d1b0e,
} as const;
